import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './AllFeatures.css';

export default function AllFeatures() {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = '';
      document.body.style.scrollBehavior = '';
    }, 100);
  }, []);

  const features = [
    {
      id: 'smart-learning',
      icon: 'fa-graduation-cap',
      title: 'Smart Learning',
      subtitle: 'AI-Powered Education',
      description: 'Personalized, data-driven learning experiences that adapt to each student\'s pace and learning style with AI-powered content delivery.',
      highlights: [
        'Adaptive content delivery tailored to individual needs',
        'Real-time progress tracking and mastery monitoring'
      ],
      className: 'smart-learning'
    },
    {
      id: 'teacher',
      icon: 'fa-chalkboard-user',
      title: 'Teacher Portal',
      subtitle: 'Empower Educators',
      description: 'Comprehensive tools for educators to manage classes, track student progress, create assignments, and communicate effectively with parents.',
      highlights: [
        'Grade book and attendance management',
        'Assignment creation and submission tracking'
      ],
      className: 'teacher'
    },
    {
      id: 'student',
      icon: 'fa-user-graduate',
      title: 'Student Hub',
      subtitle: 'Engage & Excel',
      description: 'A centralized platform for students to access coursework, submit assignments, track progress, and engage with learning materials seamlessly.',
      highlights: [
        'Access all courses and learning materials',
        'Submit assignments and view grades instantly'
      ],
      className: 'student'
    },
    {
      id: 'analytics',
      icon: 'fa-chart-line',
      title: 'Analytics Dashboard',
      subtitle: 'Data-Driven Insights',
      description: 'Powerful analytics and reporting tools that provide actionable insights into student performance, attendance, and institutional metrics.',
      highlights: [
        'Real-time performance metrics and trends',
        'Customizable reports and data visualization'
      ],
      className: 'analytics'
    },
    {
      id: 'secure-access',
      icon: 'fa-shield-halved',
      title: 'Secure Access',
      subtitle: 'Enterprise Security',
      description: 'Bank-level security with role-based access control, data encryption, and compliance with educational data privacy regulations.',
      highlights: [
        'Multi-factor authentication (MFA)',
        'Role-based access control (RBAC)'
      ],
      className: 'secure'
    },
    {
      id: 'cloud',
      icon: 'fa-cloud',
      title: 'Cloud Based Platform',
      subtitle: 'Access Anywhere',
      description: 'Fully cloud-based infrastructure ensuring 99.9% uptime, automatic backups, and seamless access from any device, anywhere, anytime.',
      highlights: [
        '99.9% guaranteed uptime',
        'Automatic data backups and recovery'
      ],
      className: 'cloud'
    },
    {
      id: 'communication',
      icon: 'fa-comments',
      title: 'Communication Hub',
      subtitle: 'Stay Connected',
      description: 'Unified communication platform connecting teachers, students, parents, and administrators with instant messaging, announcements, and notifications.',
      highlights: [
        'Real-time messaging and group chats',
        'Automated notifications and announcements'
      ],
      className: 'communication'
    },
    {
      id: 'transport',
      icon: 'fa-bus',
      title: 'Transport Tracking',
      subtitle: 'Real-Time Safety',
      description: 'GPS-enabled real-time tracking of school buses with live location updates, route monitoring, and automated parent notifications for enhanced student safety.',
      highlights: [
        'Live GPS tracking of all school vehicles',
        'Automated pickup and drop-off notifications'
      ],
      className: 'transport'
    }
  ];

  return (
    <div className="all-features-page">
      <header className="header">
        <div className="header-container">
          <Link to="/" className="brand">
            <img src="/AstraVision_Logo.png" alt="Astravision" />
          </Link>
          
          <div className="center-text-wrapper">
            <p className="center-text">Best School Management Software</p>
          </div>
          <div className="demo-btn-wrapper">
            <button 
              onClick={() => navigate('/demo-form')}
              className="demo-btn"
            >
              <span>Book a Demo</span>
            </button>
          </div>
        </div>
      </header>

      <main className="main-container">
        <div className="features-grid">
          {features.map(feature => (
            <article 
              key={feature.id}
              id={feature.id}
              className={`feature-card ${feature.className}`}
            >
              <div className="feature-icon">
                <i className={`fa-solid ${feature.icon}`}></i>
              </div>
              <h2 className="feature-title">{feature.title}</h2>
              <p className="feature-subtitle">{feature.subtitle}</p>
              <p className="feature-description">
                {feature.description}
              </p>
              <ul className="feature-highlights">
                {feature.highlights.map((highlight, idx) => (
                  <li key={idx}>{highlight}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <section className="cta-section">
          <h2>Ready to Transform Your School?</h2>
          <p>Join thousands of educational institutions worldwide using Astravision to deliver exceptional learning experiences.</p>
          <div className="cta-buttons">
            <button 
              onClick={() => navigate('/demo-form')}
              className="btn btn-cta btn-cta-white"
            >
              <i className="fa-solid fa-rocket"></i>
              <span>Try School App Now</span>
            </button>
            <button 
              onClick={() => navigate('/demo-form')}
              className="btn btn-cta btn-cta-white"
            >
              <i className="fa-solid fa-rocket"></i>
              <span>Start Free Trial</span>
            </button>
            <button 
              onClick={() => navigate('/')}
              className="btn btn-cta btn-cta-outline"
            >
              <i className="fa-solid fa-home"></i>
              <span>Back to Home</span>
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
